import styled from 'styled-components';

import { Select } from 'components/Toolkit/Inputs/Select';
import { Button } from 'components/Toolkit/Button/Button';

import { media } from 'helpers/breakpoints';

export interface StripeBuyNowProps {
  quantity: number;
  cdnUrl?: string;
  className?: string;
  buyNowSuccess?: boolean;
  buttonDisplayText?: string;
  depositEnabled?: boolean;
  handleCheckout: () => Promise<void> | void;
  setStripeQuantity: (t: number) => void;
}

const OuterContainer = styled.div<{ depositEnabled: boolean }>`
  display: flex;
  align-items: flex-end;

  ${media.medium} {
    button {
      min-width: 140px;
    }
  }
`;

const InnerContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-grow: 1;
  position: relative;

  ${media.medium} {
    flex-wrap: nowrap;
    flex-grow: 0;
  }
`;

const SelectContainer = styled.div`
  width: 72px;
`;

const SSelect = styled(Select)`
  select {
    width: 72px;
  }
`;

const SButton = styled(Button)<{
  showSelect: boolean;
  depositEnabled: boolean;
}>`
  flex: 1;
  margin-bottom: ${({ theme }) => theme.spacing.S8};
  margin-left: ${({ theme, showSelect }) =>
    showSelect ? theme.spacing.M16 : 0};

  ${media.medium} {
    flex: ${({ depositEnabled }) =>
      depositEnabled ? `0 1 100%` : `0 1 140px`};
    margin-bottom: 0;
  }

  ${media.large} {
    padding: ${({ theme }) => `0 ${theme.spacing.S8}`};
  }
`;

const IconContainer = styled.div`
  display: none;

  img:first-child {
    margin-bottom: ${({ theme }) => theme.spacing.S8};
  }

  ${media.medium} {
    display: inline-block;
    margin-left: ${({ theme }) => theme.spacing.M16};

    img {
      display: block;
      max-width: none;
    }
  }
`;

const MobileOnlyIconContainer = styled.div`
  display: flex;
  flex: 1 100%;
  justify-content: space-between;
  border-radius: ${({ theme }) => theme.borderRadius.default};
  background-color: ${({ theme }) => theme.colors.GREY_LIGHTER};
  padding: ${({ theme }) => `${theme.spacing.S4} ${theme.spacing.S8}`};

  ${media.medium} {
    display: none;
  }
`;

function mapSelectOptions(limit: number) {
  const SelectOptions = [];
  for (let i = 1; i <= limit; i++) {
    SelectOptions.push(i.toString());
  }
  return SelectOptions;
}

function StripeBuyNow({
  quantity,
  cdnUrl,
  className,
  buttonDisplayText = 'Buy Now',
  depositEnabled = false,
  handleCheckout,
  setStripeQuantity,
}: StripeBuyNowProps) {
  const showSelect = Boolean(quantity > 1);

  return (
    <OuterContainer
      className={className}
      data-testid="stripe-buy-now"
      depositEnabled={depositEnabled}
    >
      <InnerContainer>
        {showSelect && (
          <SelectContainer>
            <SSelect
              name="stripe-options"
              id={`${quantity}`}
              options={mapSelectOptions(quantity)}
              onChange={(value: string) => {
                setStripeQuantity(parseInt(value));
              }}
              willUseSubText={false}
            />
          </SelectContainer>
        )}
        <SButton
          onClick={handleCheckout}
          showSelect={showSelect}
          depositEnabled={depositEnabled}
        >
          {buttonDisplayText}
        </SButton>
        <IconContainer>
          <img
            src={`${cdnUrl}/images/illustrations/visa-master-icon.svg`}
            alt=""
          />
          <img
            src={`${cdnUrl}/images/illustrations/powered-by-stripe.svg`}
            alt=""
          />
        </IconContainer>
        <MobileOnlyIconContainer>
          <img
            src={`${cdnUrl}/images/illustrations/visa-master-icon.svg`}
            alt=""
          />
          <img
            src={`${cdnUrl}/images/illustrations/powered-by-stripe.svg`}
            alt=""
          />
        </MobileOnlyIconContainer>
      </InnerContainer>
    </OuterContainer>
  );
}

export { StripeBuyNow };
